import * as Yup from 'yup';

const schema = Yup.object({
  size: Yup.mixed()
    .required('Rengaskoko on valittava.')
    .label('Rengaskoko'),
  vehicle_type_id: Yup.string()
    .nullable()
    .label('Ajoneuvon tyyppi'),
  traffic_id: Yup.number()
    .nullable()
    .label('Kuorma'),
  over_median: Yup.array(Yup.number()).required()
});

export default schema;
export type Schema = ReturnType<typeof schema.cast>;
